import type { DateTime } from "luxon"

import { TodayRounded } from "@mui/icons-material"
import { Button, Tooltip } from "@mui/material"
import { getDefaultWorkCycleDateRange } from "utils/dateRange"

type WorkCycleDateRange = {
  endDate: DateTime
  startDate: DateTime
}

type Props = {
  endDate: DateTime
  onChange: (range: WorkCycleDateRange) => void
  startDate: DateTime
}

const CurrentWorkCycleButton = ({ endDate, onChange, startDate }: Props) => {
  const currentPeriod = getDefaultWorkCycleDateRange()
  const isCurrentPeriod =
    startDate.isValid &&
    endDate.isValid &&
    startDate.hasSame(currentPeriod.startDate, "day") &&
    endDate.hasSame(currentPeriod.endDate, "day")
  const periodLabel = `${currentPeriod.startDate.toFormat("dd/MM/yyyy")} – ${currentPeriod.endDate.toFormat(
    "dd/MM/yyyy",
  )}`

  return (
    <Tooltip title={`Kỳ lương ${periodLabel}`}>
      <span>
        <Button
          aria-label={`Chọn kỳ lương hiện tại ${periodLabel}`}
          onClick={() => onChange(currentPeriod)}
          size="small"
          startIcon={<TodayRounded fontSize="small" />}
          sx={{ color: isCurrentPeriod ? "text.secondary" : "primary.main" }}
          variant="text"
        >
          Kỳ hiện tại
        </Button>
      </span>
    </Tooltip>
  )
}

export default CurrentWorkCycleButton
